import React from 'react';
import './YearItem.scss';
import {connect} from "react-redux";
import Counters from "../../Counters/Counters";
import {Card, CardActionArea, CardActions, CardContent, CardMedia} from "@mui/material";
import Typography from "@mui/material/Typography";
import config from "../../../../api/config";
import {cardMediaStyles} from "../../../../styles/styles";

function YearItem(props) {
	const {item} = props;
	return <Card sx={{ maxWidth: 800 }}>
		<CardActionArea>
			<CardContent>
				<Typography className={(parseInt(props.currentNavigationYear) === item.eventsYear ? " active" : "")} gutterBottom variant="h5" component="div">
					{item.eventsYear}
				</Typography>
			</CardContent>
			<CardMedia
				component="img"
				image={props.label !== null ? (props.label !== false ? config.thumbnailLambdaUrl + '?key=/' + props.label.userimage + (props.label.transform ? '&transform=' + props.label.transform : '') : "/noimage.jpg") : '/loading.gif'}
				alt="Year Cover"
				sx={cardMediaStyles}
			/>
			<CardActions sx={{ pt: 2, pr: 2.5, pb: 1, pl: 1, minHeight: 64 }}>
				<Counters item={item} />
			</CardActions>
		</CardActionArea>
	</Card>
}

const mapStateToProps = state => {
	return {
		currentNavigationYear: state.eventsData.currentNavigationYear
	};
};

export default connect(mapStateToProps)(YearItem);
